import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { API, axios, formatIcelandicNumber } from "@/utils/constants";

export const PaymentDialog = ({
  open, onOpenChange,
  paymentApp, setPaymentApp,
  paymentAmount, setPaymentAmount,
  fetchApplications,
}) => {
  const showPaymentDialog = open;
  const setShowPaymentDialog = onOpenChange;
  return (
<Dialog open={showPaymentDialog} onOpenChange={setShowPaymentDialog}>
  <DialogContent className="max-w-sm">
    <DialogHeader>
      <DialogTitle className="text-sm">Innborgun</DialogTitle>
    </DialogHeader>
    {paymentApp && (
      <div className="space-y-2 py-1">
        <div>
          <p className="text-[10px] text-gray-500">Lántaki</p>
          <p className="font-semibold text-xs">{paymentApp.borrower_info.full_name}</p>
        </div>
        <div>
          <p className="text-[10px] text-gray-500">Núverandi skuld</p>
          <p className="font-semibold text-xs">
            {formatIcelandicNumber(Math.round(paymentApp.remaining_balance || paymentApp.loan_amount))} kr.
          </p>
        </div>
        <div>
          <Label className="text-[10px]">Upphæð innborgunar</Label>
          <Input
            className="h-7 text-xs"
            type="number"
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
            placeholder="Sláðu inn upphæð"
          />
        </div>
        <div className="flex justify-end space-x-2 pt-1">
          <Button
            variant="outline"
            size="sm" className="h-6 text-[10px] px-2"
            onClick={() => {
              setShowPaymentDialog(false);
              setPaymentApp(null);
              setPaymentAmount("");
            }}
          >
            Hætta við
          </Button>
          <Button
            size="sm" className="h-6 text-[10px] px-2"
            className="bg-green-600 hover:bg-green-700 h-6 text-[10px] px-2"
            onClick={async () => {
              if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
                toast.error("Vinsamlegast sláðu inn gilda upphæð");
                return;
              }

              try {
                const amount = parseFloat(paymentAmount);
                const currentBalance = paymentApp.remaining_balance || paymentApp.loan_amount;
                const newBalance = Math.max(0, currentBalance - amount);

                // Create payment record
                const payment = {
                  amount: amount,
                  payment_date: new Date().toISOString(),
                  remaining_balance_after: newBalance
                };

                // Get current payments array and add new payment
                const currentPayments = paymentApp.payments || [];
                const updatedPayments = [...currentPayments, payment];

                // Determine status: if balance is 0, mark as closed, otherwise keep approved
                const newStatus = newBalance === 0 ? "closed" : "approved";

                // Update loan with new balance and payment history
                await axios.patch(`${API}/loans/${paymentApp.id}`, {
                  remaining_balance: newBalance,
                  payments: updatedPayments,
                  status: newStatus
                });

                // Show appropriate success message
                if (newBalance === 0) {
                  toast.success(`Innborgun ${formatIcelandicNumber(Math.round(amount))} kr. skráð. Lán að fullu greitt - staða breytt í Lokið! 🎉`);
                } else {
                  toast.success(`Innborgun ${formatIcelandicNumber(Math.round(amount))} kr. skráð`);
                }
                
                setShowPaymentDialog(false);
                setPaymentApp(null);
                setPaymentAmount("");
                
                // Refresh applications
                fetchApplications();
              } catch (error) {
                console.error("Error recording payment:", error);
                toast.error("Villa kom upp við að skrá innborgun");
              }
            }}
          >
            Skrá innborgun
          </Button>
        </div>
      </div>
    )}
  </DialogContent>
</Dialog>

  );
};
